import { c as _c } from "react/compiler-runtime";
import type { DocumentDI } from '@onefootprint/types';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import getDataLabel from '../utils/get-data-label';
const useDataLabelText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "fieldset.documents.details.ocr.labels"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = key => {
      const field = getDataLabel(key);
      if (field === "full_name") {
        return t(_temp);
      }
      if (field === "name") {
        return t(_temp2);
      }
      if (field === "first_name") {
        return t(_temp3);
      }
      if (field === "middle_name") {
        return t(_temp4);
      }
      if (field === "last_name") {
        return t(_temp5);
      }
      if (field === "dob") {
        return t(_temp6);
      }
      if (field === "ssn4") {
        return t(_temp7);
      }
      if (field === "ssn9") {
        return t(_temp8);
      }
      if (field === "gender") {
        return t(_temp9);
      }
      if (field === "full_address") {
        return t(_temp10);
      }
      if (field === "address_line1") {
        return t(_temp11);
      }
      if (field === "address_line2") {
        return t(_temp12);
      }
      if (field === "city") {
        return t(_temp13);
      }
      if (field === "state") {
        return t(_temp14);
      }
      if (field === "postal_code") {
        return t(_temp15);
      }
      if (field === "zip") {
        return t(_temp16);
      }
      if (field === "country") {
        return t(_temp17);
      }
      if (field === "document_number") {
        return t(_temp18);
      }
      if (field === "expires_at") {
        return t(_temp19);
      }
      if (field === "issued_at") {
        return t(_temp20);
      }
      if (field === "issuing_country") {
        return t(_temp21);
      }
      if (field === "issuing_state") {
        return t(_temp22);
      }
      if (field === "ref_number") {
        return t(_temp23);
      }
      if (field === "nationality") {
        return t(_temp24);
      }
      if (field === "document_type") {
        return t(_temp25);
      }
      if (field === "curp") {
        return t(_temp26);
      }
      if (field === "clave_de_elector") {
        return t(_temp27);
      }
      if (field === "us_issuing_state") {
        return t(_temp28);
      }
      return capitalize(field.split("_").join(" "));
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useDataLabelText;
function _temp($) {
  return $.fullName;
}
function _temp2($_0) {
  return $_0.fullName;
}
function _temp3($_1) {
  return $_1.firstName;
}
function _temp4($_2) {
  return $_2.middleName;
}
function _temp5($_3) {
  return $_3.lastName;
}
function _temp6($_4) {
  return $_4.dob;
}
function _temp7($_5) {
  return $_5.ssn4;
}
function _temp8($_6) {
  return $_6.ssn9;
}
function _temp9($_7) {
  return $_7.gender;
}
function _temp10($_8) {
  return $_8.fullAddress;
}
function _temp11($_9) {
  return $_9.addressLine1;
}
function _temp12($_10) {
  return $_10.addressLine2;
}
function _temp13($_11) {
  return $_11.city;
}
function _temp14($_12) {
  return $_12.state;
}
function _temp15($_13) {
  return $_13.postalCode;
}
function _temp16($_14) {
  return $_14.zip;
}
function _temp17($_15) {
  return $_15.country;
}
function _temp18($_16) {
  return $_16.documentNumber;
}
function _temp19($_17) {
  return $_17.expiresAt;
}
function _temp20($_18) {
  return $_18.issuedAt;
}
function _temp21($_19) {
  return $_19.issuingCountry;
}
function _temp22($_20) {
  return $_20.issuingState;
}
function _temp23($_21) {
  return $_21.refNumber;
}
function _temp24($_22) {
  return $_22.nationality;
}
function _temp25($_23) {
  return $_23.documentType;
}
function _temp26($_24) {
  return $_24.curp;
}
function _temp27($_25) {
  return $_25.claveDeElector;
}
function _temp28($_26) {
  return $_26.usIssuingState;
}